import axios from "axios";
import { 
  getCodesQuery, 
  getSampleFilteredQuery, 
  getSampleHeaderQuery, 
  getSiteKeySearchBarQuery, 
  getSiteMetaDataQuery, 
  getSitesQuery, 
  getSubSampleQuery, 
  getFuelsQuery, 
  getAreaQuery, 
  getGroupQuery, 
  getGroupTableQuery, 
  getAllStates, 
  getContacts, 
  alertMessages, 
  getAuditTrailItems, 
  getBulkDataJobs, 
  getBulkFileNames, 
  getSitesforMap, 
  getUniqueFuel, 
  dailySampleAvgQuery, 
  historicalFieldSampleDailiesQuery
} from "src/constants";
import { ONEDAY, errorResponse } from "src/store/common";
import moment from 'moment-timezone';
import { getAccessTokenCookie } from "src/shared/Login";

/* configHandleFuelModels is used throughout the api calls. Making it callable here*/
export const configHandleFuelModels = (data:string, token:string|null)=>{
  const cookieToken = getAccessTokenCookie(`accessToken`);
  
  return {
    method: 'post',
    url: window.location.host.includes('localhost')? `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`: `${process.env.REACT_APP_GRAPHQL_URL}`.split("api/climatology/graphql", 1)[0] + "fuelmodel/apis/graphql",
    headers: {
      'Authorization': `Bearer ${cookieToken}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': window.location.host.includes('localhost')? `${process.env.REACT_APP_FIELD_SAMPLE_API_URL}`: `${process.env.REACT_APP_GRAPHQL_URL}`.split("api/climatology/graphql", 1)[0] + "fuelmodel/apis/graphql"
    },
    data: data
  }
}
/*this is a helper to check if the value sent is All, if it is we need to send null to api*/
export const checkAlltoNull = (value:any)=>{
  if(!value || value.includes('All')){
    return null;
  }
  else{
    return value;
  }

}

/* get codes will get the codes for the dropdowns*/
export const getCodes =async (requestVars: any) => {
    let responseFromCode: {
      types: [], 
      cats:[], 
      subCats: [],
       methods: [], 
      statuses: [], 
      bulkStatuses: [], 
      bulkDataTypes: [], 
      bulkFileFormats: []
    } = {
        types: [], 
        cats:[], 
        subCats: [], 
        methods: [], 
        statuses: [], 
        bulkStatuses: [], 
        bulkDataTypes: [], 
        bulkFileFormats: []
      };
    try {
      let data = JSON.stringify({
        query: getCodesQuery,
        variables:{
          returnAll: requestVars.returnAll,
          type:requestVars.type
        }
      });
      let config = configHandleFuelModels(data, null);
      return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(function(response: any){
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const allCodes = response.data.data.getCodeTables.codes;
                if(allCodes){
                  if(requestVars.returnAll===true){
                      const types = allCodes.filter((code:any)=>code.type=== 'Fuel.fuel_type');
                      const cats = allCodes.filter((code:any)=>code.type==='Fuel.Category');
                      const subCats = allCodes.filter((code:any)=>code.type==='Fuel_Sample.Sub_Category');
                      const methods =allCodes.filter((code:any)=>code.type==='Fuel_Sample.Method');
                      const statuses = allCodes.filter((code:any)=>code.type==='fuel_sample.status');
                      const bulkStatuses = allCodes.filter((code:any)=>code.type==='bulk_data_job.status').sort((a,b) => a.code_value.localeCompare(b.code_value));
                      const bulkDataTypes = allCodes.filter((code:any)=>code.type==='bulk_data_job.dataType');
                      const bulkFileFormats = allCodes.filter((code:any)=>code.type==='bulk_data_job.fileFormat');
                      responseFromCode= {
                        types: types,
                        cats:cats,
                        subCats: subCats,
                        methods: methods,
                        statuses: statuses,
                        bulkStatuses: bulkStatuses,
                        bulkDataTypes: bulkDataTypes,
                        bulkFileFormats: bulkFileFormats
                      }
                    
                    return resolve(responseFromCode)
                  }
                  else{
                    return resolve(allCodes)
                  }
              }
            }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
      );
    }
    catch (error) {
      console.log('error', error);

    }
}
/*getCategory by type will filter dropdown for category or type according to what user selects*/
export const getCategoryByType = async( token: string|null, addAlert:any, type?:string, cat?:string, getAll?:boolean) => {
  try {
    let data = JSON.stringify({
      query: getFuelsQuery,
      variables: {
        returnAll: getAll? true: false,
        fuel_id: null,
        fuel_type: type===null || type===undefined? 'All': type,
        category: cat===null || cat===undefined? 'All':cat
      }
    });
    let config = configHandleFuelModels(data, null);
    return (
      new Promise(function (resolve, reject) {
        axios(config)
          .then(async function (response: any) {
            
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }else{
            let responseArray = response.data.data.getFuels;
            return resolve(responseArray)
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            errorResponse(error, addAlert, alertMessages.siteSampleData);
            return reject(new Error(error))
          });
      })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get the subsamples needed */
export const getSubSamples = async( token: string|null,sampleId: number)=>{
  try {
    let data = JSON.stringify({
      query: getSubSampleQuery,
      variables:{
        sample_id: sampleId,
        returnAll: false
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const subResponse = response.data.data.getSubSamples.fuelSubSamples;
                return resolve(subResponse)
              }
            })
            .catch(function (error: any) {
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will help search bars onclick action*/
export const getSiteByKey = async( token: string|null, key: string) => {
  try {
    let data = JSON.stringify({
      query: getSitesQuery,
      variables: {
        returnAll: false, 
        groupId: null,
        siteId: key,
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const sites =  response.data.data.getSites.sites;
                return resolve(sites)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will help populate the site search bar*/
export const getSiteKeysForSearch = async( token: string|null,addAlert:any) => {
  try {
    let data = JSON.stringify({
      query: getSiteKeySearchBarQuery
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const sites =  response.data.data.getSiteKeys;
                return resolve(sites)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get the site's meta data for the site meta data drop down*/
export const getSiteMetaData = async( token: string|null,addAlert:any, id: string, fuelSampleMetaDataInput: any) => {
  let siteMeta:any[];
  try {
    let data = JSON.stringify({
      query: getSiteMetaDataQuery,
      variables:{
        returnAll: false,
        fuelSampleMetadataInput: fuelSampleMetaDataInput,
        groupId: null,
        siteId: Number(id),
        siteKey: null, 
        page: null,
        perPage: null
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                siteMeta = response.data.data.getSites.sites;
                return resolve(siteMeta)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get sites for map*/
export const getSitesMap = async( token: string|null,requestVals: any) => {
  let siteMeta:any[];
  try {
    let data = JSON.stringify({
      query: getSitesforMap,
      variables:{
        returnAll: false,
        perPage: 300000,
        zoomLevel: requestVals.zoomLevel,
        fuelSampleMetadataInput: requestVals.fuelSampleMetadataInput

      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                siteMeta = response.data.data.getSites.sites;
                return resolve(siteMeta)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get samples*/
export const getSamples = async( addAlert:any, setSamplesCallComplete:any, sample: any) => {
  setSamplesCallComplete(false);
  try {
    let data = JSON.stringify({
      query: getSampleFilteredQuery,
      variables:{
        returnAll: false,
        startDate: sample.startDate && (sample.startDate).toISOString().substring(0,10) +"T00:00:00+00",
        endDate: sample.endDate && moment(moment(sample.endDate).valueOf()+ONEDAY).utc().toISOString().substring(0,10)+"T00:00:00+00",
        filterBySampleType: sample.fuel_type,
        filterByStatus: sample.status,
        filterByCategory: sample.category,
        filterBySubCategory: sample.sub_category,
        filterByMethod: sample.method,
        siteId: sample.siteId? sample.siteId: sample.site_id? sample.site_id: null,
        sortBy: sample.sortBy? sample.sortBy : null,
        sortOrder: sample.sortOrder? sample.sortOrder : null,
        page: sample.page,
        perPage: sample.rowsPerPage ===-1? null: sample.rowsPerPage
    }
    });

    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors))
              }else{
                const samplesForHeader = response.data.data.getFuelSamples.fuelSamples;
                const pageInfo = response.data.data.getFuelSamples.pageInfo;
                const returnType = {
                  samplesForHeader: samplesForHeader,
                  pageInfo: pageInfo
                }
                return resolve(returnType)
              }
            })
            .catch(function (error: any) {
                setSamplesCallComplete(true);
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    setSamplesCallComplete(true);
    console.log('error', error);
  }
};

/*this will get the site's meta data for the site meta data drop down*/
export const getHeader = async( token: string|null, addAlert:any, request: any) => {
  let header:any[];
  try {
    let data = JSON.stringify({
      query: getSampleHeaderQuery,
      variables:{
        returnAll: false,
        startDate: request.startDate? request.startDate.toISOString().substring(0,10) +"T00:00:00+00":null,
        endDate: request.endDate?moment(moment(request.endDate).valueOf()+ONEDAY).utc().toISOString().substring(0,10)+"T00:00:00+00":null,
        filterBySampleType: request.type,
        filterByStatus: request.status,
        filterByCategory: request.category,
        filterBySubCategory: request.subCategory,
        filterByMethod: request.method,
        siteId: request.id,
        sortBy:request.sortBy,
        sortOrder: request.sortOrder,
        page: null,
        perPage: null
    }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                header = response.data.data.getSampleHeaders.sampleHeaders;
                return resolve(header)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};
/*this will get the download page data for field samples*/
export const getDownloadHeaders = async(token: string|null, addAlert:any, request: any) => {
  let header:any[];
  try {
    let data = JSON.stringify({
      query: getSampleHeaderQuery,
      variables:{
        returnAll: false,
        startDate: request.startDate? request.startDate.toISOString().substring(0,10) +"T00:00:00+00":null,
        endDate: request.endDate?moment(moment(request.endDate).valueOf()+ONEDAY).utc().toISOString().substring(0,10)+"T00:00:00+00":null,
        filterByFuelId: request.fuelIds,
        filterBySampleType: request.type,
        filterByStatus: request.status,
        filterByCategory: request.category,
        filterBySubCategory: request.subCategory,
        filterByMethod: request.method,
        sortBy: request.sortBy? request.sortBy : null,
        sortOrder: request.sortOrder? request.sortOrder : null,
        siteId: request.siteId,
        page: request.page,
        perPage: request.perPage? request.perPage : null
    }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                header = response.data.data.getSampleHeaders;
                return resolve(header)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};
//** GET AREA CALL POPULATES AREA DROPDOWN*//
export const getArea = async( request:any, areaIdParam?: string) => {
  try {
    let data = JSON.stringify({
      query: getAreaQuery,
      variables: {
        returnAll: !areaIdParam, 
        areaId: checkAlltoNull(areaIdParam),
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const areas = response.data.data.getAreas.areas;
                return resolve(areas)
              }
            })
            .catch(function (error: any) {
                request.setAreaFailureCount(request.areaFailureCount+1)
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get the download page data for FuelTable*/
export const getUniqueFuels = async( token: string|null, addAlert:any, request: any) => {
  let header:any[];
  try {
    let data = JSON.stringify({
      query: getUniqueFuel,
      variables:{
        startDate: request.startDate? request.startDate.toISOString().substring(0,10) +"T00:00:00+00":null,
        endDate: request.endDate?moment(moment(request.endDate).valueOf()+ONEDAY).utc().toISOString().substring(0,10)+"T00:00:00+00":null,
        filterByFuel: request.fuel, 
        filterByStatus: request.status,
        filterByCategory: request.category,
        filterBySubCategory: request.subCategory,
        filterByMethod: request.method,
        sortBy: request.sortBy? request.sortBy : null,
        sortOrder: request.sortOrder? request.sortOrder : null,
        page: request.page,
        perPage: request.perPage? request.perPage : null
    }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                header = response.data.data.getUniqueFuels;
                return resolve(header)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

//** GET group CALL POPULATES group DROPDOWN*//
export const getGroups = async( request:any, areaParam: any) => {
  try {
    let data = JSON.stringify({
      query: getGroupQuery,
      variables: {
        returnAll: areaParam.includes('All'), 
        filterByArea: checkAlltoNull(areaParam),
        sortBy: 'group_name',
        sortOrder: 'asc'
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const groups = response.data.data.getGroups.groupDetails;
                return resolve(groups)
              }
            })
            .catch(function (error: any) {
                request.setGroupFailureCount(request.groupFailureCount+1)
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/**get call to get sites for the table */
export const getSites = async( request:any, groupId: number) => {
  request.setSiteCallComplete(false);
  try {
    let data = JSON.stringify({
      query: getSitesQuery,
      variables: {
        returnAll: false, 
        groupId: groupId,
        siteId: null,
        siteKey: null
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
                request.setSiteCallComplete(true);
                
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const sites = response.data.data.getSites.sites;
                return resolve(sites)
              }
            })
            .catch(function (error: any) {
                request.setSiteCallComplete(true);
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

//** GET group CALL POPULATES group table*//
export const getGroupTable = async(request:any) => {
  request.setCallComplete(false);
  try {
    let data = JSON.stringify({
      query: getGroupTableQuery,
      variables: {
        returnAll: request.returnAll, 
        groupId: request.groupId,
        filterByGroup: checkAlltoNull(request.groupName),
        filterByArea: checkAlltoNull(request.areaId),
        filterByStatus: checkAlltoNull(request.status),
        sortBy: request.sortBy,
        sortOrder: request.sortOrder,
        page: request.pageParam,
        perPage: request.perPageParam,
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
                request.setCallComplete(true);
                
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const groups = response.data.data.getGroups.groupDetails;
                const pageInfo =  response.data.data.getGroups.pageInfo;
                const toReturn ={
                  groups: groups,
                  pageInfo: pageInfo
                }
                return resolve(toReturn);
              }
            })
            .catch(function (error: any) {
                request.setCallComplete(true);
                request.setTableFail(request.tableFail+1)
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/** populate dropdown with states for the create group page */
export const getStatesDropdown = async(request:any) => {
  request.setStateCallComplete(false);
  try {
    let data = JSON.stringify({
      query: getAllStates,
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              request.setStateCallComplete(true);

              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const states = response.data.data.findAllStates;
                return resolve(states);
              }
            })
            .catch(function (error: any) {
                request.setStateCallComplete(true);
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/** Populate search bar with contacts for the create group page*/
export const getContactsCall = async(request: any) => {
  try {
    let data = JSON.stringify({
      query: getContacts,
      variables: {
        returnAll: request.returnAll,
        page: request.page,
        perPage: request.perPage,
        filterByLocation: checkAlltoNull(request.filterByLocation),
        filterByTitle: checkAlltoNull(request.filterByTitle),
        filterByGroup:checkAlltoNull(request.filterByGroup),
        filterByArea: checkAlltoNull(request.filterByArea),
        contactId: request.contactId,
        sortBy: 'name',
        sortOrder: 'asc'
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              
                request.setContactCallComplete(true);
                if(response.data.errors && response.data.errors.length > 0){
                  return reject(new Error(response.data.errors));
                }else{
                  const contacts = response.data.data.getContacts.contacts;
                  const pageInfo =  response.data.data.getContacts.pageInfo;
                  const toReturn ={
                    contacts: contacts,
                    pageInfo: pageInfo
                  }
                  return resolve(toReturn);
                }
            })
            .catch(function (error: any) {
                request.setContactCallComplete(true);
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/** get the audit trail items for audit log*/

export const getAuditTrail = async(request: any) => {
  try {
    let data = JSON.stringify({
      query: getAuditTrailItems,
      variables: {
        auditTrailItemId: request.auditTrailItemId, //necessary if entityType,entityId is not specified
        entityType: request.entityType, //valid Types are : "fuel.fuel_sub_sample", "fuel.fuel_sample"
        entityId: request.entityId,  //can be sample_id or sub_sample_id
        auditType: request.auditType, //valid filters are: "All", "Add","Update"
        auditField: request.auditField, //valid filters are : "All", "wet_weight","sub_category","tar_weight","site_id","sample_average_value","status","sample","dry_weight","fuel_id","method_type"
        activityStartDate: request.activityStartDate,
        activityEndDate: request.activityEndDate,
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors[0].message));
              }else{
                const auditLog = response.data.data.getAuditTrailItems;
                return resolve(auditLog);
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

export const getBulkDataFileNames = async() => {
  try {
    let data = JSON.stringify({
      query: getBulkFileNames
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve, reject) {
        axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }else{
              const fileNames = response.data.data.getBulkDataFileNames;
              return resolve(fileNames);
            }

          })
          .catch(function (error: any) {
            console.log('error', error);
            return reject(new Error(error));
          });
      }));
  } catch (error) {
    console.log('error', error);
  }
}

export const getBulkJobs = async(request: any) => {
  try {
    let data = JSON.stringify({
      query: getBulkDataJobs,
      variables: {
        returnAll: request.returnAll,
        status:  request.status,
        fileName:  request.fileName,
        uploadStartDate:  request.uploadStartDate,
        uploadEndDate:  request.uploadEndDate,
        sortBy:  request.sortBy,
        sortOrder:  request.sortOrder,
        perPage:  request.perPage,
        page: request.page,
      }
    });
    let config = configHandleFuelModels(data, null);
    return(
      new Promise(function(resolve, reject) {
        axios(config)
          .then(async function (response: any) {
            if(response.data.errors && response.data.errors.length > 0){
              return reject(new Error(response.data.errors));
            }
            else{
              const files = response.data.data.getBulkDataJobs.bulkDataJobs;
              const pageInfo = response.data.data.getBulkDataJobs.pageInfo; 
              return resolve({
                files: files,
                pageInfo: pageInfo
              });
            }
          })
          .catch(function (error: any) {
            console.log('error', error);
            return reject(new Error(error));
          });
      }));
  } catch (error) {
    console.log('error', error);
  }
};

/*this will get samples*/
export const getDailySampleAvgs = async( sample: any) => {
  try {
    let data = JSON.stringify({
      query: dailySampleAvgQuery,
      variables:{
        filterByFuelType: sample.fuel_type,
        filterByStatus: sample.status,
        filterByCategory: sample.category,
        filterBySubCategory: sample.sub_category,
        filterByMethod: sample.method,
        siteId: sample.siteId? sample.siteId: sample.site_id? sample.site_id: null,
        page: sample.page,
        perPage: sample.rowsPerPage ===-1? null: sample.rowsPerPage
    }
    });

    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const dailyAvgs = response.data.data.getDailyFuelSampleSav.dailyFuelSampleSav;
                const pageInfo = response.data.data.getDailyFuelSampleSav.pageInfo;
                const returnType = {
                  dailyAvgs: dailyAvgs,
                  dailyAvgsPageInfo: pageInfo
                }
                return resolve(returnType)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};

/*this will get samples*/
export const getHistoricFieldSampleDailies = async( sample: any) => {
  try {
    let data = JSON.stringify({
      query: historicalFieldSampleDailiesQuery,
      variables:{
        dateTimeFormat: sample.dateTimeFormat,
        endMonthDay: sample.endMonthDay,
        endYear: sample.endYear,
        startMonthDay: sample.startMonthDay,
        startYear: sample.startYear,
        siteId: sample.siteId? sample.siteId: sample.site_id? sample.site_id: null,
        category: sample.category,
        method: sample.method,
        sampleType: sample.sampleType,
        subCategory: sample.subCategory,
        status: sample.status
    }
    });

    let config = configHandleFuelModels(data, null);
    return(
        new Promise(function(resolve,reject){
            axios(config)
            .then(async function (response: any) {
              if(response.data.errors && response.data.errors.length > 0){
                return reject(new Error(response.data.errors));
              }else{
                const dailyAvgs = response.data.data?.historicalAvgMinMax;

                return resolve(dailyAvgs)
              }
            })
            .catch(function (error: any) {
                console.log('error', error);
                return reject(new Error(error))
            });
        })
    )
  }
  catch (error) {
    console.log('error', error);
  }
};